import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function euro(cents) {
  return ((cents || 0) / 100).toLocaleString("it-IT", { style: "currency", currency: "EUR" });
}

export function cashPayload(cash) {
  if (!cash || cash.option === "none" || !cash.amount) return { cash_cents: 0, cash_direction: null };
  const cents = Math.round(parseFloat(String(cash.amount).replace(",", ".")) * 100);
  return { cash_cents: isNaN(cents) ? 0 : cents, cash_direction: cash.option };
}

// Renders "chi paga chi" line for an accepted/sent version. names keyed by user id.
export function cashLine(p, nameFrom, nameTo) {
  if (!p?.cash_cents) return "Nessun conguaglio — scambio carta contro carta.";
  const payer = p.cash_payer_id === p.from_user_id ? nameFrom : nameTo;
  const benef = p.cash_beneficiary_id === p.from_user_id ? nameFrom : nameTo;
  return `${payer} versa ${euro(p.cash_cents)} a ${benef}.`;
}

const CASH_OPTS = [
  ["none", "Nessun conguaglio"],
  ["offerer_pays", "Aggiungo un conguaglio (paghi tu)"],
  ["offerer_receives", "Chiedo un conguaglio (paga la controparte)"],
];
const DELIVERY_OPTS = [["", "Da concordare"], ["shipping", "Spedizione (Italia)"], ["in_person", "Incontro di persona"]];

export function CashFields({ cash, setCash, delivery, setDelivery, disabledCash }) {
  return (
    <div className="space-y-3">
      <div>
        <Label className="text-[#CBD5E1]">Conguaglio in euro (facoltativo)</Label>
        <div className="mt-1 grid gap-1.5">
          {CASH_OPTS.map(([v, l]) => {
            const off = disabledCash && v !== "none";
            return (
              <label key={v} className={`flex items-center gap-2 rounded-lg border px-3 py-2 text-sm ${cash.option === v ? "border-[#7C3AED] bg-[#7C3AED]/10 text-[#F8FAFC]" : "border-[#2A3655] text-[#CBD5E1]"} ${off ? "opacity-40" : "cursor-pointer"}`}>
                <input type="radio" name="cash-opt" disabled={off} checked={cash.option === v}
                  onChange={() => setCash({ option: v, amount: v === "none" ? "" : cash.amount })}
                  data-testid={`cash-opt-${v}`} className="accent-[#7C3AED]" />
                {l}
              </label>
            );
          })}
        </div>
        {disabledCash && <p className="mt-1 text-xs text-[#F59E0B]">Questa persona accetta solo scambi senza conguaglio.</p>}
        {cash.option !== "none" && (
          <div className="mt-2 flex items-center gap-2">
            <Input type="number" min="0" step="0.01" value={cash.amount}
              onChange={(e) => setCash({ ...cash, amount: e.target.value })} placeholder="0,00"
              data-testid="cash-amount" className="w-32 bg-[#0B1020] border-[#2A3655]" />
            <span className="text-xs text-[#94A3B8]">€ · denaro in una sola direzione. Lo scambio resta carta contro carta.</span>
          </div>
        )}
      </div>
      <div>
        <Label className="text-[#CBD5E1]">Modalità di consegna proposta</Label>
        <div className="mt-1 flex flex-wrap gap-1.5">
          {DELIVERY_OPTS.map(([v, l]) => (
            <button key={v} type="button" onClick={() => setDelivery(v)} data-testid={`delivery-opt-${v || "none"}`}
              className={`rounded-md border px-2 py-1 text-xs ${delivery === v ? "border-[#2DD4BF] bg-[#2DD4BF]/15 text-[#2DD4BF]" : "border-[#2A3655] text-[#CBD5E1]"}`}>{l}</button>
          ))}
        </div>
      </div>
    </div>
  );
}
